import { inputLayerGroups, LayerGroup } from "fond/layers";

const baseDataLayerGroups = [inputLayerGroups.inAddress, inputLayerGroups.inParcel, inputLayerGroups.inBaseDataStreet];

/** Whether every layer in the group is present. */
export const hasLayerGroup = (layerKeys: string[], group: LayerGroup): boolean => group.layers.every(({ id }) => layerKeys.includes(id));

/** Names of the group's layers that are not present. */
export const getMissingLayerNames = (layerKeys: string[], group: LayerGroup): string[] =>
  group.layers.filter(({ id }) => !layerKeys.includes(id)).map(({ name }) => name);

/** Whether the version has leadins plus an underground or aerial network. */
export const isDataPrepComplete = (layerKeys: string[]): boolean =>
  hasLayerGroup(layerKeys, inputLayerGroups.inLeadIns) &&
  (hasLayerGroup(layerKeys, inputLayerGroups.inUnderground) || hasLayerGroup(layerKeys, inputLayerGroups.spanPole));

/** Names of the base data layers (addresses, parcels, streets) that are not present. */
export const getMissingBaseDataLayerNames = (layerKeys: string[]): string[] =>
  baseDataLayerGroups.flatMap((group) => getMissingLayerNames(layerKeys, group));

/** Whether the base data layers are present along with a candidate network. */
export const isInputDataComplete = (layerKeys: string[]): boolean =>
  getMissingBaseDataLayerNames(layerKeys).length === 0 && isDataPrepComplete(layerKeys);
